import Vue from 'vue'
const axios = require("axios").default; //this js should be the only one with direct axios import
import Language from "@/lib/tars.js" 

const state = {
  isLoading: false
};

const mutations = {
  SET_LOADING(state, isLoading) {
    this.state.caller.isLoading = isLoading;
  }
}

const actions = {
  async fetchData({
    dispatch,
    rootState,
    commit
  }, opt) {
    
    opt.setLoading = (opt.setLoading != undefined ? opt.setLoading : true)

    if (opt.setLoading)
      commit("SET_LOADING", true);

    //these assignments might look redundant but save us on code duplication
    opt.api = opt.api || "one";
    opt.method = opt.method || "get";

    opt.data = opt.data || {};
    opt.contentType = opt.contentType || "application/json";
    if (opt.api == "one") {
      //not elegant, because proceess is undefined at eval
      opt.url = `${process.env.VUE_APP_API_ONE}` + `/${opt.url}`;
    } else if (opt.api == "internal") {
      opt.url = `${process.env.VUE_APP_API_INTERNAL}` + `/${opt.url}`;
    }
    return await axios({
        headers: {
          Authorization: "bearer " + rootState.auth.apis[opt.api]["token"],
          "Content-Type": opt.contentType,
          "cache-control": "no-cache",
          Accept: "*/*"
        },
        method: opt.method,
        data: opt.data,
        url: opt.url
      })
      .then(function (response) {
        commit("SET_LOADING", false);
        
        if (response.data.HasError) {
          // Check if the response is validation error
          
          if (response.data.IsValidationError) {
            Vue.noty.error(new Language().getMessageException(response.data.ErrorMessage))
          } else {
            Vue.noty.error(new Language().getMessageException('except_not_threated'))          
          }
        } else return response.data; //returns to dispatcher

      })
      .catch(async function (error) {
        commit("SET_LOADING", false);
        if (error.response == undefined) {
          return
        }        
        if (error.response.status == 401) {
          //not authenticated so tries to authenticate, then re-dispatch it, QoS
          await dispatch(
            "auth/getTokenWithApp", {
              data: {},
              api: opt.api
            }, {
              root: true
            }
          ).then(() => {
            dispatch(
              opt.dispatcher, {
                data: opt.data,
                url: opt.url,
                method: opt.method,
                api: opt.api,
                contentType: opt.contentType,
                selection: opt.selection,
                error: error.response.status
              }, {
                root: true
              }
            );
          });
        }
      });
  },

};
export default {
  state,
  namespaced: true,
  mutations,
  actions
};